module.exports = __webpack_public_path__ + "static/img/蒙版组 12.b0e565b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/declaration/images/蒙版组 12.png
// module id = NXb2
// module chunks = 0